export const ROOM_DETAILS_LIST_REQUEST = "ROOM_DETAILS_LIST_REQUEST"
export const ROOM_DETAILS_LIST_SUCCESS = "ROOM_DETAILS_LIST_SUCCESS"
export const ROOM_DETAILS_LIST_FAILED = "ROOM_DETAILS_LIST_FAILED"

export const ROOM_DETAILS_GET_REQUEST = "ROOM_DETAILS_GET_REQUEST"
export const ROOM_DETAILS_GET_SUCCESS = "ROOM_DETAILS_GET_SUCCESS"
export const ROOM_DETAILS_GET_FAILED = "ROOM_DETAILS_GET_FAILED"

export const ROOM_DETAILS_UPDATE_REQUEST = "ROOM_DETAILS_UPDATE_REQUEST"
export const ROOM_DETAILS_UPDATE_SUCCESS = "ROOM_DETAILS_UPDATE_SUCCESS"
export const ROOM_DETAILS_UPDATE_FAILED = "ROOM_DETAILS_UPDATE_FAILED"

export const ROOM_DETAILS_UPDATE_SORT_ORDER_REQUEST = "ROOM_DETAILS_UPDATE_SORT_ORDER_REQUEST"
export const ROOM_DETAILS_UPDATE_SORT_ORDER_SUCCESS = "ROOM_DETAILS_UPDATE_SORT_ORDER_SUCCESS"
export const ROOM_DETAILS_UPDATE_SORT_ORDER_FAILED = "ROOM_DETAILS_UPDATE_SORT_ORDER_FAILED"

export const ROOM_DETAILS_PROCESS_CLEAR = "ROOM_DETAILS_PROCESS_CLEAR"

export type RoomContent = {
  lang: string
  display_name: string
  description: string
  highlights?: string[]
  amenities?: string[]
}

export type RoomData = {
  id: number | null
  room_code: string
  cover_image?: string | null
  name?: string
  max_avail?: number | null
  avail_offset?: number | null
  images?: string[]
  contents: RoomContent[]
  sort_order?: number | null
  enabled: boolean
}

export type RoomDetailsListResponse = RoomData[]

export type SortOrderItem = {
  room_id: number
  sort_order: number
}

export type RoomDetailsSortOrderUpdateRequestPayload = {
  prop_code: string
  items: SortOrderItem[]
}

export type RoomDetailsGetRequestPayload = {
  roomCode: string
}

export type RoomDetailsUpdateRequestPayload = {
  prop_code: string
} & RoomData

export type RoomDetailsListRequest = {
  type: typeof ROOM_DETAILS_LIST_REQUEST
}

export type RoomDetailsListSuccess = {
  type: typeof ROOM_DETAILS_LIST_SUCCESS
  payload: RoomDetailsListResponse
}

export type RoomDetailsListFailed = {
  type: typeof ROOM_DETAILS_LIST_FAILED
  payload: string
}

export type RoomDetailsGetRequest = {
  type: typeof ROOM_DETAILS_GET_REQUEST
  payload: RoomDetailsGetRequestPayload
}

export type RoomDetailsGetSuccess = {
  type: typeof ROOM_DETAILS_GET_SUCCESS
  payload: RoomData
}

export type RoomDetailsGetFailed = {
  type: typeof ROOM_DETAILS_GET_FAILED
  payload: string
}

export type RoomDetailsUpdateRequest = {
  type: typeof ROOM_DETAILS_UPDATE_REQUEST
  payload: RoomData
}

export type RoomDetailsUpdateSuccess = {
  type: typeof ROOM_DETAILS_UPDATE_SUCCESS
}

export type RoomDetailsUpdateFailed = {
  type: typeof ROOM_DETAILS_UPDATE_FAILED
  payload: string
}

export type RoomDetailsProcessClear = {
  type: typeof ROOM_DETAILS_PROCESS_CLEAR
}

export type RoomDetailsUpdateSortOrderRequest = {
  type: typeof ROOM_DETAILS_UPDATE_SORT_ORDER_REQUEST
  payload: SortOrderItem[]
}

export type RoomDetailsUpdateSortOrderSuccess = {
  type: typeof ROOM_DETAILS_UPDATE_SORT_ORDER_SUCCESS
}

export type RoomDetailsUpdateSortOrderFailed = {
  type: typeof ROOM_DETAILS_UPDATE_SORT_ORDER_FAILED
  payload: string
}

export type RoomDetailsConfigAction =
  | RoomDetailsListRequest
  | RoomDetailsListSuccess
  | RoomDetailsListFailed
  | RoomDetailsGetRequest
  | RoomDetailsGetSuccess
  | RoomDetailsGetFailed
  | RoomDetailsUpdateRequest
  | RoomDetailsUpdateSuccess
  | RoomDetailsUpdateFailed
  | RoomDetailsUpdateSortOrderRequest
  | RoomDetailsUpdateSortOrderSuccess
  | RoomDetailsUpdateSortOrderFailed
  | RoomDetailsProcessClear
